import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="relative overflow-hidden rounded-[14px] bg-primary text-primary-foreground">
        <div aria-hidden="true" className="signal-grid-lines absolute inset-0 opacity-[0.14]" />
        <div className="relative p-7 md:p-12 lg:p-16">
          {variant === "split" ? (
            <CallToActionSplit {...props} />
          ) : (
            <CallToActionStacked {...props} />
          )}
        </div>
      </div>
    </DaylightSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
